import React, { memo } from "react";

const ReadyMadeFormStatus = memo(function ReadyMadeFormStatus({
  draftRestored,
  isEditing,
  conflictMessage,
  error,
  submitError,
  submitDisabled,
  discardDraft,
}) {
  return (
    <>
      {draftRestored ? (
        <div className="admin-feedback admin-feedback--info admin-form-banner">
          <div>
            A saved draft was restored for this ready-made product.
            {isEditing ? " Review changes before saving." : ""}
          </div>

          <button
            type="button"
            className="admin-btn admin-btn--secondary"
            onClick={discardDraft}
            disabled={submitDisabled}
          >
            Discard draft
          </button>
        </div>
      ) : null}

      {conflictMessage ? (
        <div className="admin-feedback admin-feedback--error">
          {conflictMessage}
        </div>
      ) : null}

      {error && !conflictMessage ? (
        <div className="admin-feedback admin-feedback--error">{error}</div>
      ) : null}

      {submitError ? (
        <div className="admin-feedback admin-feedback--error">
          {submitError}
        </div>
      ) : null}
    </>
  );
});

export default ReadyMadeFormStatus;
